// extracted by mini-css-extract-plugin
module.exports = {"raceInfo":"_8b5ddbc","eachWay":"_3f9c7e2"};